import constants from '@/app-configs/constants'

export default async function mainComponent() {
  return [
    {
      title: 'DEBTIA_MY_CASES',
      icon: 'FolderIcon',
      route: 'home',
      action: constants.action.read,
      resource: constants.resource.auth,
    },
    {
      title: 'DEBTIA_MESSAGES',
      icon: 'MessageSquareIcon',
      route: 'messages',
      action: constants.action.read,
      resource: constants.resource.auth,
    },
    {
      title: 'DEBTIA_DOCUMENTS',
      icon: 'FileTextIcon',
      route: 'documents',
      action: constants.action.read,
      resource: constants.resource.auth,
    },
    {
      title: 'DEBTIA_FAQ',
      icon: 'HelpCircleIcon',
      route: 'faq',
      action: constants.action.read,
      resource: constants.resource.auth,
    },
  ]
}
